export default {
  sm: `
  Different records and memories we make every day get stored in a data center.
  Keeping data that is the record of our lives secure, and keeping our environment and future whole. These are the responsibilities of DATA CENTER GAK as a technology platform. To enable the knowledge of today to become the foundation of knowledge for the next generation, DATA CENTER GAK continues its efforts for a better environment.
  `,
};
